import EventSection from "../components/EventSection";
import { useAuth } from "../hooks/useAuth";

export default function Events() {
  const { user } = useAuth();

  return (
    <div className="flex grow flex-col items-center">
      {/* Projects */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <EventSection pageSize={7} />
      </div>
    </div>
  );
}
